export function typeOf(type) {
  const constructor = (input) => ({ type, [type]: input })
  constructor.is = (input) => typeof input === 'object' && input.type === type
  constructor.toString = () => type
  return constructor
}
